<template>
  <div :class="`alert-box--${type}`" class="alert-box is-flex">
    <div class="alert-box__message-box">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AlertMessage',
  props: {
    type: {
      // Possible values: info
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/vendor/_breakpoints.scss";

.alert-box {
  &--info {
    background-color: rgba(48, 170, 225, 0.1);
  }

  &__message-box {
    font-size: 14px;
    padding: 15px 19px 13px;

    @include mobile {
      font-size: 12px;
      padding: 11px 19px 9px;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AlertMessage.vue